import HeaderSpan from './HeaderSpan'
import StatItem from './StatItem'
import { langStatList } from '../assets/langStatList'
import { useLang } from '../utils/hooks'
import { sessionColors } from '../assets/colors'

const StatList = ({ list, handleSelectNewItem, handleSort, textClass }) => {
  const background = sessionColors.headerCl
  const { lang } = useLang()
  const choosenLang = lang === 'eng' ? langStatList.eng : langStatList.fr
  const listStats = list.listStatsPage
  const sortOrder = list.sortOrder.isReverse
  const sortType = list.sortOrder.sortType

  const onSort = (columnType) => {
    handleSort(columnType)
  }

  const handleClickOnItem = (event) => {
    let itemId = event.target.id
    const item = listStats.filter((stat) => {
      return Number(itemId) === stat.year
    })[0]
    handleSelectNewItem(item)
  }

  const w_a = ['25', '25', '50']

  let i = 0
  let row_i = 0

  return (
    <div className={'content ' + textClass}>
      <div className="block">
        <div style={{ display: 'flex', width: '100%' }}>
          <HeaderSpan
            headerTitle={choosenLang.stat_year_head}
            background={background}
            columnType={'YEAR_SORT'}
            sortType={sortType}
            sortOrder={sortOrder}
            w={w_a[i]}
            handleOnClick={onSort}
            align={'left'}
          />
          <HeaderSpan
            headerTitle={choosenLang.stat_nb_head}
            background={background}
            columnType={'NB_SORT'}
            sortType={sortType}
            sortOrder={sortOrder}
            w={w_a[++i]}
            handleOnClick={onSort}
            align={'right'}
          />
          <HeaderSpan
            headerTitle={choosenLang.stat_duration_head}
            background={background}
            columnType={'DURATION_SORT'}
            sortType={sortType}
            sortOrder={sortOrder}
            w={w_a[++i]}
            handleOnClick={onSort}
            align={'right'}
          />
        </div>
      </div>
      <div className="block">
        {listStats.map((oneStat) => {
          row_i++
          return (
            <StatItem
              key={oneStat.year}
              stat={oneStat}
              onClick={handleClickOnItem}
              isGrey={row_i % 2 === 1}
              isSelected={oneStat.bg}
              wA={w_a}
            ></StatItem>
          )
        })}
      </div>
    </div>
  )
}

export default StatList
